import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initializeAuth } from '../store/authSlice';
import { AppDispatch } from '../store/store';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Initialize Firebase authentication state
    // The auth listener will remain active throughout the app lifecycle
    dispatch(initializeAuth());
    
    // Note: The auth listener cleanup is handled automatically when the app unmounts
    // or the browser tab/window closes, so no explicit cleanup is needed here
  }, [dispatch]);

  return <>{children}</>;
};

export default AuthProvider; 